import { Component, OnInit, OnDestroy , ChangeDetectionStrategy } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GmsapidataService } from '../../core/services/gmsapidata.service';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from "file-saver";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-export',
    templateUrl: './export.component.html',
    styleUrls: ['./export.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportComponent implements OnInit, OnDestroy {
  private getReportsSub: Subscription;
  private today = new Date();
  private fileName: string;
  private expertData: any;
  constructor(private gmsApiService: GmsapidataService, private snackBar: MatSnackBar) {}

  ngOnInit (): void {
  }

  public exportData (exportVal, apiResponse, fileName) {
    this.fileName = fileName;
    if (exportVal == "xls") {
      this.exportExcel(apiResponse);
    } else {
      this.exportCSV(apiResponse);
    }
  }
  private exportExcel (apiResponse): void {
    var totalData = JSON.parse(JSON.stringify(apiResponse));
    if (totalData.length > 0) {
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(totalData);
      // generate workbook and add the worksheet 
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      //Date and time with file extension 
      let EXCEL_EXTENSION = '.xlsx';
      var date = this.today.getFullYear() + '-' + (this.today.getMonth() + 1) + '-' + this.today.getDate();
      var time = this.today.getHours() + ':' + this.today.getMinutes() + ':' + this.today.getSeconds();
      var dateTime = date + '-' + time;
      // save to file 
      XLSX.writeFile(wb, this.fileName + dateTime + EXCEL_EXTENSION);
    } else {
      this.snackBar.open("Oops! Something went wrong.", 'x', {
        duration: 5000
      });
    }
  }
  private exportCSV (apiResponse) {
    var totalData = JSON.parse(JSON.stringify(apiResponse));;
    if (totalData.length > 0) {
      this.expertData = totalData;
      const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
      const header = Object.keys(this.expertData[0]);
      let csv = this.expertData.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
      csv.unshift(header.join(','));
      let csvArray = csv.join('\r\n');
      // Date and time with file extension 
      let EXCEL_EXTENSION = '.csv';
      var date = this.today.getFullYear() + '-' + (this.today.getMonth() + 1) + '-' + this.today.getDate();
      var time = this.today.getHours() + ':' + this.today.getMinutes() + ':' + this.today.getSeconds();
      var dateTime = date + '-' + time;
      var blob = new Blob([csvArray], { type: 'text/csv' });
      saveAs(blob, this.fileName + dateTime + EXCEL_EXTENSION);
    } else {
      this.snackBar.open("Oops! Something went wrong.", 'x', {
        duration: 5000
      });
    }
  }
  ngOnDestroy () {
    if (this.getReportsSub)
      this.getReportsSub.unsubscribe();
  }
}
